import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectCurrencies,
  selectCurrencyError,
  selectHasCurrencyError,
  selectIsCurrencyLoaded,
  selectIsCurrencyLoading,
} from '../currency/currency.selectors';
import {
  selectError,
  selectHasError,
  selectIsLoaded,
  selectIsLoading,
  selectSettings,
} from '../selectors/operator-settings.selectors';

@Injectable({ providedIn: 'root' })
export class OperatorSettingsSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly settings = this._store.selectSignal(selectSettings);
  public readonly isLoading = this._store.selectSignal(selectIsLoading);
  public readonly isLoaded = this._store.selectSignal(selectIsLoaded);
  public readonly hasError = this._store.selectSignal(selectHasError);
  public readonly error = this._store.selectSignal(selectError);

  public readonly currencies = this._store.selectSignal(selectCurrencies);
  public readonly isCurrencyLoading = this._store.selectSignal(
    selectIsCurrencyLoading,
  );
  public readonly isCurrencyLoaded = this._store.selectSignal(
    selectIsCurrencyLoaded,
  );
  public readonly hasCurrencyError = this._store.selectSignal(
    selectHasCurrencyError,
  );
  public readonly currencyError = this._store.selectSignal(selectCurrencyError);
}
